package com.patronat.top.features.usermanagement.domain.usecase.command

import com.patronat.top.domain.usecase.Command

class GetCurrentUserCommand : Command